import { useLottie } from "lottie-react";
import loading from "./Loading.json";

const LoadingLottie = () => {
    const options = {
        animationData: loading,
        loop: true,
        style: {
            height: "25px",
            width: "25px",
        },
    };
    const { View } = useLottie(options);
    return <>{View}</>;
};
export default LoadingLottie;
